export default __webpack_public_path__ + "static/media/retry-icon-white.85eb4d27.svg";